import { Action } from '@ngrx/store';
import { RecetaRequestModel } from '../models/store.model';

export const SET_RECETA_REQUEST = '[Transacciones] Set Receta Request';
export const UNSET_RECETA_REQUEST = '[Transacciones] Unset Receta Request';

export class SetRecetaRequest implements Action {
    readonly type = SET_RECETA_REQUEST;
    constructor(public payload: RecetaRequestModel) {}
}

export class UnsetRecetaRequest implements Action {
    readonly type = UNSET_RECETA_REQUEST;
}

export type RecetaActions = SetRecetaRequest | UnsetRecetaRequest;
